/* eslint-disable indent */
import React from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { zoneIgnoredDate } from 'utils/helpers';
import { Typography } from '@mui/material';

export const Date = (props, _, format, ignoreZone = false) => {
  let value = props?.cell?.value;
  const renderEmptyString =
    props?.cell?.column?.renderEmptyStringForUndefinedValue;

  if (typeof value === 'boolean') {
    return value ? 'True' : 'False';
  }
  if (!value) {
    if (renderEmptyString) return '';
    return 'N/A';
  }
  if (DateTime.fromISO(value).isValid) {
    value = ignoreZone ? zoneIgnoredDate(value) : DateTime.fromISO(value);
  } else if (DateTime.fromJSDate(value).isValid) {
    value = ignoreZone
      ? DateTime.fromJSDate(value.fromJSDate().slice(0, 10), {
          zone: 'utc',
        }).startOf('day')
      : DateTime.fromJSDate(value);
  } else {
    // eslint-disable-next-line no-console
    console.error('Value provided for `Date` cell component is not accepted');
    return value;
  }

  value = format
    ? value.toFormat(format, { locale: 'en-US' })
    : value.toLocaleString(DateTime.DATE_SHORT);

  return <Typography>{value}</Typography>;
};

Date.propTypes = {
  cell: PropTypes.object,
};
